import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {setUserViewMode} from 'actions/index.js';
import {SPOTLIGHT, MIXES, LINKS, COLORS} from 'constants/user-view-modes.js';
import ConnectToUserModal from './ConnectToUserModal.js';
import DirectMessageModal from './DirectMessageModal.js';

class ProfileNavigatorComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showConnectModal: false,
            showMessageModal: false,
        };
    }

    onClickDirectMessage() {
        this.setState({showMessageModal: true});
    }

    onClickConnect() {
        this.setState({showConnectModal: true});
    }

    onClickMessage() {

    }

    render() {
        return (
            <div className="profile-navigator">
              <DirectMessageModal
                userName={this.props.userName}
                userId={this.props.userId}
                hide={() => this.setState({showMessageModal: false})}
                show={this.state.showMessageModal}/>
              <ConnectToUserModal
                userName={this.props.userName}
                ethereum={this.props.ethereum}
                guilds={this.props.guilds}
                userId={this.props.userId}
                hide={() => this.setState({showConnectModal: false})}
                show={this.state.showConnectModal}/>
              <div
                onClick={() => this.props.setUserViewMode(SPOTLIGHT)}
                className={this.props.viewMode === SPOTLIGHT ? "selected navigator-option" : "navigator-option"}>
                Spotlight
              </div>
              <div
                onClick={() => this.props.setUserViewMode(MIXES)}
                className={this.props.viewMode === MIXES ? "selected navigator-option" : "navigator-option"}>
                Mixes
              </div>
              <ConditionedComponent condition={this.props.isEditing}>
                <div
                  onClick={() => this.props.setUserViewMode(LINKS)}
                  className={this.props.viewMode === LINKS ? "selected navigator-option" : "navigator-option"}>
                  Links 
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.props.hasEditsToSave && this.props.isEditing}>
                <div
                  onClick={this.props.onClickSave}
                  className="navigator-option save-option">
                  SAVE
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={true}>
                <div className="left-buttons">
                  <div>
                    <img
                      onClick={() => this.onClickDirectMessage()}
                      className="direct-message-button" src="/direct-message.png"/>
                  </div>
                  <div
                    onClick={() => this.onClickConnect()}
                    className="common-button pink-button connect-button">CONNECT</div>
                </div>
              </ConditionedComponent>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        viewMode: state.user.viewMode,
        hasEditsToSave: state.user.hasEditsToSave,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setUserViewMode: (viewMode) => dispatch(setUserViewMode(viewMode)),
    };
};

 
export default connect(mapStateToProps, mapDispatchToProps)(ProfileNavigatorComponent);
